import { Badge, Button } from '@seen/ui'
import { IconCopy } from '@tabler/icons-react'
import type { ReactNode } from 'react'
import { toast } from 'sonner'
import { Tooltip } from '#src/components/core/tooltip/Tooltip.tsx'
import { TooltipContent } from '#src/components/core/tooltip/TooltipContent.tsx'
import { TooltipTrigger } from '#src/components/core/tooltip/TooltipTrigger.tsx'

export function MRNBadge({ mrn }: { mrn: string }): ReactNode {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Badge variant="outline" className="select-none">
          MRN {mrn}
        </Badge>
      </TooltipTrigger>
      <TooltipContent onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center gap-4">
          MRN {mrn}
          <Button
            variant="ghost"
            size="icon"
            className="-m-3"
            onClick={() => {
              void navigator.clipboard.writeText(mrn)
              toast.success(`${mrn} copied to clipboard`)
            }}
          >
            <IconCopy className="size-4" />
          </Button>
        </div>
      </TooltipContent>
    </Tooltip>
  )
}
